import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las variables de entorno de Supabase');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type UserRole = 'employer' | 'candidate' | 'admin';

export interface Profile {
  id: string;
  email: string;
  full_name: string;
  role: UserRole;
  phone?: string;
  company_name?: string;
  company_description?: string;
  resume_url?: string;
  skills?: string[];
  experience_years?: number;
  location?: string;
  avatar_url?: string;
  subscription_status: 'active' | 'inactive' | 'trial';
  subscription_expires_at?: string;
  created_at: string;
  updated_at: string;
  is_banned?: boolean;
  ban_reason?: string;
}

export interface Job {
  id: string;
  employer_id: string;
  title: string;
  description: string;
  company_name: string;
  location: string;
  salary_min?: number;
  salary_max?: number;
  job_type: 'full-time' | 'part-time' | 'contract' | 'freelance' | 'internship';
  category: string;
  requirements?: string[];
  benefits?: string[];
  status: 'active' | 'inactive' | 'closed' | 'pending' | 'rejected';
  views_count: number;
  applications_count: number;
  created_at: string;
  updated_at: string;
  application_email?: string;
  is_paid?: boolean;
  payment_amount?: number;
  coupon_used?: string;
  rejection_reason?: string;
  contract_type?: string;
  experience_level?: string;
  salary_period?: string;
  remote_policy?: string;
  positions_available?: number;
  urgency?: string;
  schedule?: string;
  languages_required?: string[];
  skills_required?: string[];
}

export interface Application {
  id: string;
  job_id: string;
  candidate_id: string;
  cover_letter?: string;
  resume_url?: string;
  status: 'pending' | 'viewed' | 'reviewed' | 'incomplete' | 'in_progress' | 'hired' | 'accepted' | 'rejected';
  created_at: string;
  updated_at: string;
  viewed_by_employer?: boolean;
  viewed_at?: string;
}

export interface Message {
  id: string;
  sender_id: string;
  receiver_id: string;
  application_id?: string;
  content: string;
  is_read: boolean;
  created_at: string;
}

export interface Notification {
  id: string;
  user_id: string;
  title: string;
  message: string;
  type: 'application' | 'message' | 'job' | 'system';
  is_read: boolean;
  link?: string;
  created_at: string;
}
